import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  IndexWrapper,
  Statistics,
  ProductPromo,
  Photo,
  Category,
  Order,
  Parameter,
  Product,
  Kanban,
  ServiceType,
} from "@framework/shared";

import { EcommerceSection } from "../dashboard/ecommerce";

export const ecommerceRoutes: Array<RouteObject> = [
  {
    path: "/ecommerce",
    index: true,
    element: (
      <IndexWrapper index="ecommerce">
        <EcommerceSection />
      </IndexWrapper>
    ),
  },
  {
    path: "/ecommerce/products",
    element: <Protected />,
    children: [
      { index: true, element: <Product service={ServiceType.ADMIN} /> },
      { path: "/ecommerce/products/:id/:action", element: <Product service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/ecommerce/categories",
    element: <Protected />,
    children: [
      { index: true, element: <Category service={ServiceType.ADMIN} /> },
      { path: "/ecommerce/categories/:id/:action", element: <Category service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/ecommerce/parameters",
    element: <Protected />,
    children: [
      { index: true, element: <Parameter service={ServiceType.ADMIN} /> },
      { path: "/ecommerce/parameters/:id/:action", element: <Parameter service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/ecommerce/promos",
    element: <Protected />,
    children: [
      { index: true, element: <ProductPromo service={ServiceType.ADMIN} /> },
      { path: "/ecommerce/promos/:id/:action", element: <ProductPromo service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/ecommerce/kanban",
    element: <Protected />,
    children: [
      { index: true, element: <Kanban service={ServiceType.ADMIN} /> },
      { path: "/ecommerce/kanban/:id/:action", element: <Kanban service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/ecommerce/orders",
    element: <Protected />,
    children: [
      { index: true, element: <Order service={ServiceType.ADMIN} /> },
      { path: "/ecommerce/orders/:id/:action", element: <Order service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/ecommerce/photos",
    element: <Protected />,
    children: [{ index: true, element: <Photo service={ServiceType.ADMIN} /> }],
  },
  {
    path: "/ecommerce/statistics",
    element: <Protected />,
    children: [{ index: true, element: <Statistics /> }],
  },
];
